// --------------------------------------------------------
// EXAMES FIELD - ExamesField
// --------------------------------------------------------

// --------------------------------------------------------
// GENERAL
// --------------------------------------------------------
import { Autocomplete, TextField } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import styled from "styled-components";
import {
  H3,
  Text,
} from "../../../../../../../components/UI/generalLayout/Layout.styled";
import { insertElementIntoList } from "../../../../../../../helpers/HelperFunctions";
import useResponsiveInfo from "../../../../../../../hooks/useResponsiveInfo";
import Exam from "../../../../../../../models/core/careLine/Exam";
import AddButtonField from "../AddButtonField";
import { CheckBox } from "../DetailsAttendanceRecord.styled";
import { ReactComponent as Trash } from "../../../../../../../assets/imgs/trashBin.svg";
import { removeFieldFromList } from "../../../../../../../helpers/CareLineHelperFunctions";
import { ExamService } from "../../../../../../../core/http/service/ExamService";

// --------------------------------------------------------

// --------------------------------------------------------
// IMPORTS
// --------------------------------------------------------
// --------------------------------------------------------

// --------------------------------------------------------
// EXAMES FIELD INTERFACE
// --------------------------------------------------------

interface IExamesField {
  exames: any[];
  extraExams: any[];
  setExtraExams: any;
  selectedExames: any[];
  setSelectedExames: any;
  isViewState: boolean;
}
/**
/**
 * A component that renders a Component description here.
 *
 * @param props The component props.
 * @returns The component JSX.
 */
export const ExamsArea = styled.div`
  padding: 16px;
  background: #f8fafc;
  border-radius: 16px;
`;
const ExamesField = ({
  exames,
  selectedExames,
  setSelectedExames,
  isViewState,
  extraExams,
  setExtraExams,
}: IExamesField) => {
  // --------------------------------------------------------
  // EXAMES FIELD PRIVATE DECLARATIONS
  // --------------------------------------------------------

  // --------------------------------------------------------
  const { isMobile } = useResponsiveInfo();
  const [examsOption, setExamsOptions] = useState<any[]>([]);

  const fetchExams = async (event: any, newValue: any | null) => {
    const examService: ExamService = new ExamService();
    const examResponse: any = await examService.getAll(newValue);

    setExamsOptions(examResponse.data.data);
  };

  // --------------------------------------------------------
  // REACT RETURN FUNCTION
  // --------------------------------------------------------
  return (
    <>
      <div>
        <H3>Selecione exames*</H3>
        <ExamsArea>
          {exames.map((ex) => {
            return (
              <div style={{ flexDirection: "row", display: "flex", gap: 10 }}>
                <CheckBox
                  type="checkbox"
                  checked={
                    selectedExames.findIndex((exame: any) => {
                      return exame.id === ex.id;
                    }) !== -1
                  }
                  disabled={isViewState}
                  style={{ marginTop: 17 }}
                  onChange={() => {
                    setSelectedExames((prev: any) => {
                      const list = [...prev];
                      const elementIndex = list.findIndex(
                        (el) => el.id === ex.id
                      );
                      elementIndex === -1
                        ? list.push(ex)
                        : list.splice(elementIndex, 1);
                      return list;
                    });
                  }}
                />
                <Text>{ex.nome}</Text>
              </div>
            );
          })}
        </ExamsArea>
        {extraExams.length > 0 && <H3>Exames adicionais</H3>}
        {extraExams.map((extraExam: any, index: number) => {
          return (
            <div
              style={{
                marginBottom: 10,
                display: "flex",
                flexDirection: isMobile ? "column" : "row",
                gap: isMobile ? 7 : 15,
              }}
            >
              <Autocomplete
                disabled={isViewState}
                value={extraExam.exame}
                autoComplete
                includeInputInList
                filterSelectedOptions
                filterOptions={(x) => x}
                getOptionLabel={(option) => (option.nome ? option.nome : "")}
                noOptionsText="Nenhum exame encontrado"
                onInputChange={(event, newInputValue) => {
                  if (newInputValue.length >= 3) {
                    fetchExams(event, newInputValue);
                  } else {
                    setExamsOptions([]);
                  }
                }}
                onChange={(event: any, newValue: any | null) => {
                  setExtraExams((prev: any) => {
                    const isNull = newValue === null;
                    const list = [...prev];
                    return insertElementIntoList(
                      list,
                      {
                        exame: {
                          id: isNull ? "" : newValue.id,
                          nome: isNull ? "" : newValue.nome,
                        },
                        justificativa: list[index].justificativa,
                      },
                      index
                    );
                  });
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    size={"small"}
                    style={{ backgroundColor: "white" }}
                    label="Selecione o exame"
                  />
                )}
                options={examsOption}
                sx={{ width: 400 }}
              />
              <TextField
                    value={extraExam.justificativa}
                    size={"small"}
                    style={{ backgroundColor: "white" }}
                    label="Justificativa para o exame"
                    onChange={(event)=>{
                      setExtraExams((prev: any) => {
                        const list = [...prev];
                        list[index].justificativa = event.target.value;
                        return list;
                      });
                    }}
              />
              {!isViewState && (
                <Trash
                  style={{ marginTop: isMobile ? 0 : 7, marginBottom: isMobile ? 15 : 0, cursor: "pointer" }}
                  onClick={() => {
                    setExtraExams(removeFieldFromList(extraExams, index));
                  }}
                />
              )}
            </div>
          );
        })}

        {!isViewState && (
          <AddButtonField
            buttonText="Adicionar outro tipo de exame"
            onClickFunction={() => {
              setExtraExams((prev: any) => {
                return [...prev, {exame: {id: "", nome: "",}, justificativa: "" }];
              });
            }}
          />
        )}
      </div>
    </>
  );
  // --------------------------------------------------------
};

export default ExamesField;
